/**
 * The two units this pane prints, formatted once.
 *
 * German thousands are a narrow no-break space, not a point: `2 500 ft`. A point
 * is a decimal separator on the paper form (`2.5` in the Sicherheitshöhe column
 * means two thousand five hundred feet), so a thousands point in the same pane
 * would be the one ambiguity that matters here.
 */

/** `2 500 ft` */
export const feetText = (ft: number): string => groupThousands(ft) + ' ft';

/** `2 500` */
export const groupThousands = (n: number): string =>
  Math.round(n).toLocaleString('de-DE').replace(/\./g, ' ');

/** `8.4 NM`, `87 NM` — a decimal only where it changes the answer. */
export const nmText = (nm: number): string => (nm < 10 ? String(Math.round(nm * 10) / 10) : groupThousands(nm)) + ' NM';

/** `+1 200 ft` / `−300 ft` — a clearance is a difference and reads as one. */
export const signedFeet = (ft: number): string =>
  (ft > 0 ? '+' : ft < 0 ? '−' : '') + groupThousands(Math.abs(ft)) + ' ft';
